// react
import { useCallback } from 'react';

// capacitor
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

// store
import { useRegisterPushNotificationTokenMutation } from 'store/api/account';

export const usePushNotification = () => {
  // hooks
  const [registerPushNotificationToken] =
    useRegisterPushNotificationTokenMutation();

  // methods
  const registerForPushNotifications = useCallback(async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Push notifications not available on web');
      return;
    }

    const platform = Capacitor.getPlatform();

    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive !== 'granted') {
      console.error('Push notification permission denied');
      return;
    }

    await PushNotifications.register();

    // registration listener
    PushNotifications.addListener('registration', async (token) => {
      try {
        await registerPushNotificationToken({
          token: token.value,
          platform,
        });
      } catch (error) {
        console.error('Error registering push notification token:', error);
      }
    });

    // error listener
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push notification registration error:', error);
    });
  }, [registerPushNotificationToken]);

  const cleanup = useCallback(() => {
    if (Capacitor.isNativePlatform()) {
      PushNotifications.removeAllListeners();
    }
  }, []);

  return {
    registerForPushNotifications,
    cleanup,
  };
};
